import { render, staticRenderFns } from "./KAutocomplete.vue?vue&type=template&id=4c5a601a&"
import script from "./KAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./KAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports